import { render, staticRenderFns } from "./ElementCheckbox.vue?vue&type=template&id=574c97b6&scoped=true"
import script from "./ElementCheckbox.vue?vue&type=script&lang=js"
export * from "./ElementCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ElementCheckbox.vue?vue&type=style&index=0&id=574c97b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c97b6",
  null
  
)

export default component.exports